import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';
import { GetDraftArticlesCacheKey } from '../queries/useGetDraftArticlesQuery';
import { toast } from 'react-toastify';

enum DeleteDraftArticleCacheKey {
  DeleteDraftArticle = 'DeleteDraftArticle',
}

export const useDeleteDraftArticleMutation = () => {
  const { deleteDraftArticle } = useServicesContext();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DeleteDraftArticleCacheKey.DeleteDraftArticle],
    mutationFn: ({ draftId }: { draftId: number }) =>
      deleteDraftArticle(draftId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetDraftArticlesCacheKey.GetDraftArticles],
      });
    },
    onError: (error) =>
      toast.error(
        `Kunne ikke slette utkast: ${error.message || 'Ukjent feil oppstod'}`,
        { position: 'bottom-right' },
      ),
  });
};
